import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogInfoComponent } from '../components/dialog-info/dialog-info.component';
import { FieldValidation } from 'src/app/models/ValidateCrewInfo';

@Injectable({
  providedIn: 'root'
})
export class AccessRestrictionDialogService {

  constructor(private dialog: MatDialog) {}

  open(data: {
    invalidFields?: FieldValidation[];
    active?: boolean;
    valid?: boolean;
    blocked?: boolean;
    accessDeniedMessage?: string;
  }): void {
    const manualIssueLink = 'https://docs.google.com/forms/d/e/1FAIpQLSegn7zNha_cdiqzdE-EAdLpbdq5mx--g-BwmFA3AxZvXirn0g/viewform';
    const passeLivreEmail = 'passetriplatam@latam.com';
    const invalidFields = data.invalidFields ?? [];
    const active = data.active ?? true;
    const valid = data.valid ?? true;
    const blocked = data.blocked ?? false;

    let html = '<div class="text-left">';

    if (blocked) {
      html += `
        <p>
          ${data.accessDeniedMessage ?? 'Identificamos que seu acesso ao benefício Passe Livre está temporariamente bloqueado.'}
        </p>
      `;
    } else if (!active && data.accessDeniedMessage) {
      html += `
        <p>
          ${data.accessDeniedMessage}
        </p>
      `;
    } else if (!active) {
      html += `
        <p>
          Identificamos que você está de Licença Não Remunerada (LNR) ou Afastamento Previdenciário (INSS) e/ou CMA vencido.<br>
          Neste caso, não poderá emitir o passe.
        </p>
      `;
    }

    if (!valid && invalidFields.length > 0) {
      html += `
        <p>Identificamos os seguintes erros em seu cadastro:</p>
        <ul>
          ${invalidFields.map(field => `<li>${field.message}</li>`).join('')}
        </ul>
        <p>Favor entrar em contato para regularização através do RH Connect > Enviar uma solicitação > Tripulantes > Cadastro.</p>
      `;
    }

    html += `
      <p>
        Caso a informação não proceda e precise de emissão de passe urgente,
        comunique-se por este <a href="${manualIssueLink}" target="_blank">link</a>
        ou pelo <a href="mailto:${passeLivreEmail}">${passeLivreEmail}</a>.
      </p>`;

    html += '</div>';

    this.dialog.open(DialogInfoComponent, {
      width: '600px',
      data: { title: 'Notificação', html }
    });
  }
}
